import Seo from "@/components/base/Seo";
import Hero from "./components/Hero";
import HotTicker from "./components/HotTicker";
import Channels from "./components/Channels";
import Featured from "./components/Featured";
import CategoryGrid from "./components/CategoryGrid";
import Process from "./components/Process";
import Voices from "./components/Voices";
import FaqPreview from "./components/FaqPreview";
import CtaBanner from "./components/CtaBanner";
import { siteInfo } from "@/mocks/site";
import { faqs } from "@/mocks/faqs";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "511爆料",
    url: "https://cqkczx.cn/",
    description:
      "511爆料是一个面向大众的匿名投稿与瓜料分享平台，支持私信投稿、投喂瓜料、我要爆料等多种投喂方式。",
    email: siteInfo.email,
    slogan: siteInfo.slogan,
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "511爆料",
    url: "https://cqkczx.cn/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://cqkczx.cn/square?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "511爆料官网 | 匿名投稿平台 私信投稿直达后台",
    url: "https://cqkczx.cn/",
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", url: "https://cqkczx.cn/" },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.slice(0, 5).map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="511爆料官网 | 匿名投稿平台 私信投稿直达后台"
        description="511爆料是面向大众的匿名投稿与瓜料分享平台，支持511爆料匿名投稿、私信投稿、我要爆料等多种投喂方式，线索直达后台审核，严格保护投稿人隐私，瓜料被采纳后进入热门发酵环节。"
        canonical="https://cqkczx.cn/"
        keywords="511爆料,511爆料匿名投稿,511爆料我要爆料,511爆料私信投稿,511爆料投喂瓜料,511爆料线索直达"
        jsonLd={homeJsonLd}
      />
      <Hero />
      <HotTicker />
      <Channels />
      <Featured />
      <CategoryGrid />
      <Process />
      <CtaBanner />
      <Voices />
      <FaqPreview />
    </>
  );
}